module.exports = __webpack_public_path__ + "img/draw2_img3.5e4a67ab.png";